import getDisplayInformation from '../../data-driven-logo/get-display-information';

const nameOverrideMap = {
  2: 'USPS from ShipStation',
  103: 'UPS from ShipStation',
};

export const getSellerLabelProviderNameOverride = (labelProvider) => {
  const { labelProviderId, useHouseCredentials } = labelProvider;
  if (useHouseCredentials) {
    return nameOverrideMap[labelProviderId];
  }
};

const overrideSellerLabelProviderNickname = (sellerLabelProvider) => {
  const nameOverride = getSellerLabelProviderNameOverride(sellerLabelProvider);
  if (nameOverride) {
    return {
      ...sellerLabelProvider,
      name: nameOverride,
    };
  }
  return sellerLabelProvider;
};

export const getMappedSellerProviderList = (sellerLabelProviders, sellerProviderRates, providerServices) => {
  const rateMetaDefault = { rates: [] };

  // Map existing providers
  const mappedProviders = sellerLabelProviders.map((sellerLabelProvider) => {
    const hiddenServicesForProvider = providerServices
      .filter((serv) => serv.labelProviderId === sellerLabelProvider.labelProviderId && serv.isHidden)
      .map((serv) => serv.serviceId);
    const sellerProviderRatesMeta =
      sellerProviderRates.find((rate) => rate.sellerLabelProviderId === sellerLabelProvider.sellerLabelProviderId) || rateMetaDefault;
    const providerDisplayInformation = getDisplayInformation({
      providerId: Number.parseInt(sellerLabelProvider.labelProviderId, 10),
    });

    const sellerProviderWithOverrides = overrideSellerLabelProviderNickname({
      ...sellerLabelProvider,
      ...sellerProviderRatesMeta,
      rates: sellerProviderRatesMeta.rates.filter((rate) => !hiddenServicesForProvider.includes(rate.serviceId)),
      providerDisplayInformation,
    });
    return sellerProviderWithOverrides;
  });

  // Include any consolidated service collections
  const pseudoServiceCollectionProvider = sellerProviderRates.filter((rate) => rate.isServiceCollection);

  return [...mappedProviders, ...pseudoServiceCollectionProvider];
};
